import { returnError } from './helperFunc';
import {
    getSchedulerStatusAction,
    runDistributorSchedulerAction,
    runMonthlySchedulerAction,
    runYearlySchedulerAction,
    runDailySchedulerAction,
    runTerminalTTSSchedulerAction,
    runTerminalCashlessSchedulerAction,
    runTerminalCashlessThailandSchedulerAction,
} from './requestEndpoints';

const SET_SCHEDULER_LOADING = 'SET_SCHEDULER_LOADING';
const CLEAR_SCHEDULER_ERROR = 'CLEAR_SCHEDULER_ERROR';
const GET_SCHEDULER_STATUS_SUCCESS = 'GET_SCHEDULER_STATUS_SUCCESS';
const GET_SCHEDULER_STATUS_FAIL = 'GET_SCHEDULER_STATUS_FAIL';

const RUN_DISTRIBUTOR_SCHEDULER_SUCCESS = 'RUN_DISTRIBUTOR_SCHEDULER_SUCCESS';
const RUN_DISTRIBUTOR_SCHEDULER_FAIL = 'RUN_DISTRIBUTOR_SCHEDULER_FAIL';

const RUN_MONTHLY_SCHEDULER_SUCCESS = 'RUN_MONTHLY_SCHEDULER_SUCCESS';
const RUN_MONTHLY_SCHEDULER_FAIL = 'RUN_MONTHLY_SCHEDULER_FAIL';

const RUN_YEARLY_SCHEDULER_SUCCESS = 'RUN_YEARLY_SCHEDULER_SUCCESS';
const RUN_YEARLY_SCHEDULER_FAIL = 'RUN_YEARLY_SCHEDULER_FAIL';

const RUN_DAILY_SCHEDULER_SUCCESS = 'RUN_DAILY_SCHEDULER_SUCCESS';
const RUN_DAILY_SCHEDULER_FAIL = 'RUN_DAILY_SCHEDULER_FAIL';

const RUN_TERMINAL_TTS_SCHEDULER_SUCCESS = 'RUN_TERMINAL_TTS_SCHEDULER_SUCCESS';
const RUN_TERMINAL_TTS_SCHEDULER_FAIL = 'RUN_TERMINAL_TTS_SCHEDULER_FAIL';

const RUN_TERMINAL_CASHLESS_SCHEDULER_SUCCESS = 'RUN_TERMINAL_CASHLESS_SCHEDULER_SUCCESS';
const RUN_TERMINAL_CASHLESS_SCHEDULER_FAIL = 'RUN_TERMINAL_CASHLESS_SCHEDULER_FAIL';

const RUN_TERMINAL_CASHLESS_THAILAND_SCHEDULER_SUCCESS = 'RUN_TERMINAL_CASHLESS_THAILAND_SCHEDULER_SUCCESS';
const RUN_TERMINAL_CASHLESS_THAILAND_SCHEDULER_FAIL = 'RUN_TERMINAL_CASHLESS_THAILAND_SCHEDULER_FAIL';

// Action to get scheduler status
export const getSchedulerStatus = () => async (dispatch, getState) => {
    try {
        const { adminReducer } = getState();
        const token = adminReducer ? adminReducer.token : '';
        const { data } = await getSchedulerStatusAction(token);

        dispatch({ type: GET_SCHEDULER_STATUS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: GET_SCHEDULER_STATUS_FAIL, payload: returnError(error) });
    }
};

// Action to run distributor scheduler
export const runDistributorScheduler = (params) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_SCHEDULER_LOADING });
        dispatch({ type: CLEAR_SCHEDULER_ERROR });

        const { adminReducer } = getState();
        const token = adminReducer ? adminReducer.token : '';
        const { data } = await runDistributorSchedulerAction(params, token);

        dispatch({ type: RUN_DISTRIBUTOR_SCHEDULER_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: RUN_DISTRIBUTOR_SCHEDULER_FAIL, payload: returnError(error) });
    }
};

// Action to run monthly scheduler
export const runMonthlyScheduler = (params) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_SCHEDULER_LOADING });
        dispatch({ type: CLEAR_SCHEDULER_ERROR });

        const { adminReducer } = getState();
        const token = adminReducer ? adminReducer.token : '';
        const { data } = await runMonthlySchedulerAction(params, token);

        dispatch({ type: RUN_MONTHLY_SCHEDULER_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: RUN_MONTHLY_SCHEDULER_FAIL, payload: returnError(error) });
    }
};

// Action to run yearly scheduler
export const runYearlyScheduler = (params) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_SCHEDULER_LOADING });
        dispatch({ type: CLEAR_SCHEDULER_ERROR });

        const { adminReducer } = getState();
        const token = adminReducer ? adminReducer.token : '';
        const { data } = await runYearlySchedulerAction(params, token);

        dispatch({ type: RUN_YEARLY_SCHEDULER_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: RUN_YEARLY_SCHEDULER_FAIL, payload: returnError(error) });
    }
};

// Action to run daily scheduler
export const runDailyScheduler = (params) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_SCHEDULER_LOADING });
        dispatch({ type: CLEAR_SCHEDULER_ERROR });

        const { adminReducer } = getState();
        const token = adminReducer ? adminReducer.token : '';
        const { data } = await runDailySchedulerAction(params, token);

        dispatch({ type: RUN_DAILY_SCHEDULER_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: RUN_DAILY_SCHEDULER_FAIL, payload: returnError(error) });
    }
};

// Action to run terminal TTS scheduler
export const runTerminalTTSScheduler = (params) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_SCHEDULER_LOADING });
        dispatch({ type: CLEAR_SCHEDULER_ERROR });

        const { adminReducer } = getState();
        const token = adminReducer ? adminReducer.token : '';
        const { data } = await runTerminalTTSSchedulerAction(params, token);

        dispatch({ type: RUN_TERMINAL_TTS_SCHEDULER_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: RUN_TERMINAL_TTS_SCHEDULER_FAIL, payload: returnError(error) });
    }
};

// Action to run terminal cashless scheduler
export const runTerminalCashlessScheduler = (params) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_SCHEDULER_LOADING });
        dispatch({ type: CLEAR_SCHEDULER_ERROR });

        const { adminReducer } = getState();
        const token = adminReducer ? adminReducer.token : '';
        const { data } = await runTerminalCashlessSchedulerAction(params, token);

        dispatch({ type: RUN_TERMINAL_CASHLESS_SCHEDULER_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: RUN_TERMINAL_CASHLESS_SCHEDULER_FAIL, payload: returnError(error) });
    }
};

// Action to run terminal cashless Thailand scheduler
export const runTerminalCashlessThailandScheduler = (params) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_SCHEDULER_LOADING });
        dispatch({ type: CLEAR_SCHEDULER_ERROR });

        const { adminReducer } = getState();
        const token = adminReducer ? adminReducer.token : '';
        const { data } = await runTerminalCashlessThailandSchedulerAction(params, token);

        dispatch({ type: RUN_TERMINAL_CASHLESS_THAILAND_SCHEDULER_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: RUN_TERMINAL_CASHLESS_THAILAND_SCHEDULER_FAIL, payload: returnError(error) });
    }
};

// Action to clear error
export const clearSchedulerError = () => (dispatch) => {
    dispatch({ type: CLEAR_SCHEDULER_ERROR });
};

const initialState = {
    loading: false,
    error: null,
    distributorSchedulerResult: null,
    monthlySchedulerResult: null,
    yearlySchedulerResult: null,
    dailySchedulerResult: null,
    terminalTTSSchedulerResult: null,
    terminalCashlessSchedulerResult: null,
    terminalCashlessThailandSchedulerResult: null,
    schedulerStatus: null,
};

export const schedulerReducer = function (state = initialState, action) {
    switch (action.type) {
        case SET_SCHEDULER_LOADING:
            return {
                ...state,
                loading: true,
            };

        case CLEAR_SCHEDULER_ERROR:
            return {
                ...state,
                error: null,
            };

        case GET_SCHEDULER_STATUS_SUCCESS:
            return {
                ...state,
                schedulerStatus: action.payload,
                loading: false,
            };

        case GET_SCHEDULER_STATUS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case RUN_DISTRIBUTOR_SCHEDULER_SUCCESS:
            return {
                ...state,
                distributorSchedulerResult: action.payload,
                loading: false,
                error: null,
            };

        case RUN_DISTRIBUTOR_SCHEDULER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case RUN_MONTHLY_SCHEDULER_SUCCESS:
            return {
                ...state,
                monthlySchedulerResult: action.payload,
                loading: false,
                error: null,
            };

        case RUN_MONTHLY_SCHEDULER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case RUN_YEARLY_SCHEDULER_SUCCESS:
            return {
                ...state,
                yearlySchedulerResult: action.payload,
                loading: false,
                error: null,
            };

        case RUN_YEARLY_SCHEDULER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case RUN_DAILY_SCHEDULER_SUCCESS:
            return {
                ...state,
                dailySchedulerResult: action.payload,
                loading: false,
                error: null,
            };

        case RUN_DAILY_SCHEDULER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case RUN_TERMINAL_TTS_SCHEDULER_SUCCESS:
            return {
                ...state,
                terminalTTSSchedulerResult: action.payload,
                loading: false,
                error: null,
            };

        case RUN_TERMINAL_TTS_SCHEDULER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case RUN_TERMINAL_CASHLESS_SCHEDULER_SUCCESS:
            return {
                ...state,
                terminalCashlessSchedulerResult: action.payload,
                loading: false,
                error: null,
            };

        case RUN_TERMINAL_CASHLESS_SCHEDULER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case RUN_TERMINAL_CASHLESS_THAILAND_SCHEDULER_SUCCESS:
            return {
                ...state,
                terminalCashlessThailandSchedulerResult: action.payload,
                loading: false,
                error: null,
            };

        case RUN_TERMINAL_CASHLESS_THAILAND_SCHEDULER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};